<template>
  <main id='main' class="touch">
    <component v-if="view" :is="view" v-bind="$attrs"/>
  </main>
</template>

<script>
export default {
  name: 'blank',
  computed: {
    view () {
      return this.$route.meta.component
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
